import XLSX from 'xlsx';
import _omitBy from 'lodash/omitBy';

/**
 * @function excelToJson
 * @description Convertie un fichier excel au format json avec la library
 * js-xlsx voir {@link https://docs.sheetjs.com/#json}.
 *
 * @param {blob} File - Fichier text contenant le csv uploader
 * @returns {object} Fichier transformé en object javascript
 */
const excelToJson = file => {
  const workbook = XLSX.read(file, {
    type: 'binary'
  });
  const ws = workbook.Sheets[workbook.SheetNames[0]];
  let commands = XLSX.utils.sheet_to_json(ws, {
    defval: '',
    blankrows: false
  });
  commands = commands.map(command =>
    _omitBy(command, (value, key) => key.includes('__EMPTY'))
  );
  return commands;
};

export default excelToJson;
